/**
 * Componente Card - Sistema de Diseño Illustra
 * Contenedor base para agrupar contenido
 */

const Card = ({ 
  children, 
  title,
  subtitle,
  headerAction,
  footer,
  padding = 'md',
  hover = false,
  border = true,
  shadow = 'sm',
  className = '',
  ...props 
}) => {
  const baseClasses = `
    bg-white dark:bg-slate-800 
    rounded-xl
    transition-all duration-200
  `.trim().replace(/\s+/g, ' ');
  
  const paddingClasses = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  };
  
  const shadowClasses = {
    none: '',
    sm: 'shadow-sm',
    md: 'shadow-md',
    lg: 'shadow-lg',
    xl: 'shadow-xl'
  };
  
  const borderClass = border 
    ? 'border border-gray-200 dark:border-slate-700' 
    : '';
  
  const hoverClasses = hover 
    ? 'hover:shadow-md dark:hover:shadow-lg hover:border-indigo-300 dark:hover:border-indigo-600 cursor-pointer hover:-translate-y-0.5' 
    : '';
  
  return (
    <div 
      className={`
        ${baseClasses} 
        ${shadowClasses[shadow]}
        ${borderClass}
        ${hoverClasses} 
        ${className}
      `}
      {...props}
    >
      {/* Header */}
      {(title || subtitle || headerAction) && (
        <div className={`
          ${paddingClasses[padding]} 
          ${footer || children ? 'border-b border-gray-200 dark:border-slate-700' : ''}
        `}>
          <div className="flex items-start justify-between gap-4">
            <div className="flex-1 min-w-0">
              {title && (
                <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 truncate">
                  {title}
                </h3>
              )}
              {subtitle && (
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                  {subtitle}
                </p>
              )}
            </div>
            {headerAction && (
              <div className="flex-shrink-0">
                {headerAction}
              </div>
            )}
          </div>
        </div>
      )}
      
      {/* Content */}
      {children && (
        <div className={paddingClasses[padding]}>
          {children}
        </div>
      )}
      
      {/* Footer */}
      {footer && (
        <div className={`
          ${paddingClasses[padding]}
          border-t border-gray-200 dark:border-slate-700
          bg-gray-50 dark:bg-slate-900
          rounded-b-xl
        `}>
          {footer}
        </div>
      )}
    </div>
  );
};

export default Card;
